import Tag from '~/components/Tag'
import i from '~/i18n'

export const labels = {
  title: i.t('rm:campaign.create.ObjectiveBased.strategy.title'),
  description: {
    pending: i.t('rm:campaign.create.ObjectiveBased.strategy.description'),
    done: (goal: Goals) => (
      <>
        {i.t(
          'rm:campaign.create.ObjectiveBased.strategy.description.completed'
        )}
        <Tag>{i.t(`rm:objectiveBased.strategy.${goal}`)}</Tag>
      </>
    )
  }
}
